(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/components/filter.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/components/filter.js');

'use strict';

const _React = React,
  useMemo = _React.useMemo;
const FilterSection = svs.components.casino_react.filterAndSort.components.FilterSection;
const Accordion = svs.ui.ReactAccordion.Accordion;
const Filter = _ref => {
  let _ref$includeProviders = _ref.includeProviders,
    includeProviders = _ref$includeProviders === void 0 ? true : _ref$includeProviders;
  const searchFilters = useMemo(() => {
    if (includeProviders) {
      return svs.components.casino_react.data.searchFilters;
    }
    return svs.components.casino_react.data.searchFilters.filter(filterSection => filterSection.type !== 'providers');
  }, [includeProviders]);
  return React.createElement(Accordion, {
    branding: "inverted",
    className: "casino-filter",
    customer: "sport",
    isFlat: true
  }, searchFilters.map(filterSection => React.createElement(FilterSection, {
    filterSection: filterSection,
    key: filterSection.type
  })));
};
setGlobal('svs.components.casino_react.filterAndSort.components.Filter', Filter);

 })(window);